export default "__VITE_ASSET__d8f47d87__"